export const TRAVEL_INTERESTS = [
  { value: 'cidade_historica', label: 'Cidade Histórica' },
  { value: 'cidade_moderna', label: 'Cidade Moderna' },
  { value: 'montanha', label: 'Montanha' },
  { value: 'praia', label: 'Praia' },
  { value: 'familiar', label: 'Familiar' },
  { value: 'pet_friendly', label: 'Pet Friendly' },
  { value: 'cultural', label: 'Cultural' },
  { value: 'gastronomico', label: 'Gastronômico' },
  { value: 'aventura', label: 'Aventura' },
  { value: 'romantico', label: 'Romântico' },
  { value: 'vida_noturna', label: 'Vida Noturna' },
  { value: 'ecologico', label: 'Ecológico' },
  { value: 'luxuoso', label: 'Luxuoso' },
  { value: 'religioso', label: 'Religioso' },
  { value: 'compras', label: 'Compras' },
  { value: 'fotografia', label: 'Fotografia' },
  { value: 'clima_frio', label: 'Clima Frio' },
  { value: 'clima_quente', label: 'Clima Quente' },
  { value: 'cinema', label: 'Cinema' },
  { value: 'natureza', label: 'Natureza' }
] as const

export const TRAVEL_INTEREST_VALUES = TRAVEL_INTERESTS.map(
  (interest) => interest.value
)

const INTEREST_LABELS = Object.fromEntries(
  TRAVEL_INTERESTS.map((interest) => [interest.value, interest.label])
) as Record<string, string>

export const formatInterest = (value: string) =>
  INTEREST_LABELS[value] ||
  value.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase())
